import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {PermissionListPage} from "../pages/modules/settings/permissions/PermissionListPage"
import {RoleList} from "../pages/modules/settings/roles/RoleList"
import {UsersPage} from '../pages/modules/user-management/UsersPage'
import {OrganizatoinListPage} from '../pages/modules/organizations/OrganizationListPage'
import {BranchListPage} from '../pages/modules/branches/BranchListPage'
import {useAuth} from '../modules/auth/core/Auth'
import { OrgBranchListPage } from '../pages/modules/organizations/branches/OrgBranchListPage'
import { OrgDepartmentListPage } from '../pages/modules/organizations/departments/OrgDepartmentListPage'
import { UserList } from '../pages/modules/settings/users/UserList'
import { DoctorList } from '../pages/modules/doctors/DoctorList'

const PrivateRoutes = () => {
  
  const {currentUser} = useAuth();
  
  // console.log(currentUser);
  
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  //const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='doctors' element={<DoctorList />} />
        <Route path='organizations' element={<OrganizatoinListPage />} />
        <Route path='organizations/:org_id/branches' element={<OrgBranchListPage />} />
        <Route path='branches' element={<BranchListPage/>} />
        <Route path='branches/:branch_id/departments' element={<OrgDepartmentListPage />} />
        <Route path='user-management/*' element={ <UsersPage /> } />
        <Route path='settings/permission' element={ <PermissionListPage /> } />
        <Route path='settings/role' element={ <RoleList /> } />
        <Route path='settings/user' element={ <UserList /> } />
        <Route path='*' element={<Navigate to='/auth/login' />}/>
        {/* Lazy Modules */}
        {/* Page Not Found */}
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
